export const GROUP_SETTINGS_PAGES = {
  INCIDENT_RESPONSE: 1,
  IMPERSONATION_PROTECTION: 2,
  END_USER_ALERTS: 3,
}

/** Step metadata only — keep free of page/component imports so reducers stay TurboSnap-safe. */
export const GROUP_SETTINGS_WIZARD_STEP_META = [
  {
    key: GROUP_SETTINGS_PAGES.INCIDENT_RESPONSE,
    name: 'Incident Response',
  },
  {
    key: GROUP_SETTINGS_PAGES.IMPERSONATION_PROTECTION,
    name: 'Impersonation Protection',
  },
  {
    key: GROUP_SETTINGS_PAGES.END_USER_ALERTS,
    name: 'End-user Alerts',
  },
]
